import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import CardImportacao from './card';
import './index.css';
import api from '../../services/api_adiantamento';


export default function Importacao() {

    const [importacoes, setImportacoes] = useState({});
    const [time, settime] = useState({});

    useEffect(() => {       
        
        api.get(`/importadores`).then(function (response) {
            if (response.data) {
                setImportacoes(response.data);
                setTimeout(function() {
                    settime(time+1);
                }, 3000);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, [time])

    
    return (
        <div className="container-lg">
            <Header title="GERENCIADOR DE IMPORTAÇÕES" />
            <div className="importacoes">
                <CardImportacao importacoes = {importacoes}></CardImportacao>
            </div>
        </div>
    )
}